export const isVerbWord = (word) => {
    const parsing = word?.parsing?.parsing || '';
    return word?.strongsnumber !== -1 && parsing.includes('V-');
};

export const inferVerbTiming = (word) => {
    const explicitTiming = word?.parsing?.timing;
    if (explicitTiming === 'Past' || explicitTiming === 'Present' || explicitTiming === 'Future') {
        return explicitTiming;
    }

    const parsing = word?.parsing?.parsing || '';
    if (!parsing.includes('V-')) return null;

    if (parsing.includes('ConsecImperf')) return 'Past';
    if (parsing.includes('ConjPerf')) return 'Past';
    if (parsing.includes('-Perf')) return 'Past';

    if (parsing.includes('Prtcpl')) return 'Present';

    if (parsing.includes('ConjImperf')) return 'Future';
    if (parsing.includes('-Imperf')) return 'Future';
    if (parsing.includes('-Imp-')) return 'Future';
    if (parsing.includes('Juss')) return 'Future';
    if (parsing.includes('Cohort')) return 'Future';

    return null;
};
